var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationObserver", {
    ref: "form",
    staticClass: "formbody formbody--narrow formbody--center",
    attrs: { tag: "form", novalidate: "" },
    on: {
      submit: function($event) {
        $event.preventDefault()
        return _vm.onSubmit.apply(null, arguments)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var invalid = ref.invalid
          var errors = ref.errors
          return [
            _vm.formResponse.message
              ? _c("GeneralMessage", {
                  ref: "message",
                  attrs: {
                    message: _vm.formResponse.message,
                    type: _vm.formResponse.type
                  },
                  on: {
                    close: function($event) {
                      _vm.formResponse.message = ""
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.fieldSections.length > 1
              ? _c("div", { ref: "progress", staticClass: "form-progress" }, [
                  _c("progress", {
                    staticClass: "form-progress__bar",
                    attrs: { max: _vm.fieldSections.length },
                    domProps: { value: _vm.currentSection + 1 }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.fieldSections, function(group, i) {
              return [
                _vm.currentSection >= i
                  ? _c(
                      "section",
                      {
                        key: i,
                        ref: "section",
                        refInFor: true,
                        staticClass: "form-section"
                      },
                      [
                        group.title
                          ? _c("h2", {
                              directives: [
                                {
                                  name: "sanitize",
                                  rawName: "v-sanitize",
                                  value: group.title,
                                  expression: "group.title"
                                }
                              ],
                              staticClass: "form-section__title"
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(group.fields, function(field, i) {
                          return _c("ValidationProvider", {
                            key: i,
                            staticClass: "input-wrapper",
                            attrs: {
                              name: field.field.name,
                              rules: field.rules,
                              tag: "div",
                              customMessages: field.errors
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    var invalid = ref.invalid
                                    var validated = ref.validated
                                    var dirty = ref.dirty
                                    return [
                                      field.attributes.html
                                        ? _c("div", {
                                            directives: [
                                              {
                                                name: "sanitize",
                                                rawName: "v-sanitize",
                                                value: field.attributes.html,
                                                expression:
                                                  "field.attributes.html"
                                              }
                                            ],
                                            staticClass: "form-section__text"
                                          })
                                        : [
                                            _c(
                                              field.component,
                                              _vm._b(
                                                {
                                                  tag: "component",
                                                  attrs: {
                                                    type: field.type,
                                                    error: invalid && validated,
                                                    disabled: _vm.loading
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData[
                                                        field.field.name
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formData,
                                                        field.field.name,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData[field.field.name]"
                                                  }
                                                },
                                                "component",
                                                field.attributes,
                                                false
                                              )
                                            ),
                                            _vm._v(" "),
                                            invalid && validated
                                              ? _c("span", {
                                                  staticClass: "input-error",
                                                  domProps: {
                                                    innerHTML: _vm._s(errors[0])
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.fieldSections.length &&
                _vm.currentSection === i &&
                _vm.currentSection < _vm.fieldSections.length - 1
                  ? _c("Button", {
                      attrs: {
                        level: "primary",
                        text: _vm.$t("forms.buttons.next"),
                        type: "button"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.onNextSection(i)
                        }
                      }
                    })
                  : _vm._e()
              ]
            }),
            _vm._v(" "),
            _vm.currentSection === _vm.fieldSections.length - 1
              ? _c("Button", {
                  attrs: {
                    level: "primary",
                    text: _vm.buttonText,
                    type: "submit"
                  }
                })
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }